import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  IMyPasswordFormModel,
  myPasswordFormDefaultValues,
  myPasswordFormSchema,
} from "../models/myPasswordFormModel";
import { useApiMutation } from "../../../../common/infrastructure/hooks/useApiMutation";
import { endpointsMetadata } from "../../../../common/infrastructure/routes/endpointsMetadata";

export const usePasswordForm = () => {
  const form = useForm<IMyPasswordFormModel>({
    resolver: yupResolver(myPasswordFormSchema),
    defaultValues: myPasswordFormDefaultValues,
  });

  const { mutate, isLoading } = useApiMutation({
    onSuccess: () => {
      form.reset();
    },
  });

  const onSubmit = form.handleSubmit((data) => {
    mutate({
      endpoint: endpointsMetadata.authentication.changePassword,
      method: "post",
      payload: {
        currentPassword: data.currentPassword,
        newPassword: data.newPassword,
        confirmNewPassword: data.confirmNewPassword,
      },
      successMessage: "Паролата е сменена успешно.",
    });
  });

  return {
    form,
    onSubmit,
    isSaving: isLoading,
  };
};
